import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import bigDecimal from 'js-big-decimal';

function buildDesignation(product) {
  let des = '';
  if (product.designation) des += product.designation;
  if (product.reference !== 'DIV') {
    if (product.dimensions) des += ` (${product.dimensions})`;
    if (product.marque || product.gamme) des += ' | ';
    if (product.marque) des += product.marque + ' ';
    if (product.gamme) des += product.gamme;
  }
  return des.trim();
}

function sortByColisage(products) {
  const numeric = [];
  const nonNumeric = [];

  for (const p of products) {
    const trimmed = (p.commentaire || '').trim();
    const num = Number(trimmed);
    if (trimmed !== '' && !isNaN(num)) {
      numeric.push({ product: p, num });
    } else {
      nonNumeric.push(p);
    }
  }

  numeric.sort((a, b) => a.num - b.num);
  nonNumeric.sort((a, b) =>
    (a.commentaire || '').localeCompare(b.commentaire || '')
  );

  return [...numeric.map(x => x.product), ...nonNumeric];
}

export function generatePackingListPdf({ products, clientName, comment, orderId, cmdType, hidePrices = false }) {
  const doc = new jsPDF();

  const title = cmdType === 2 ? 'Offre devis' : 'Packing list';
  const fileName = `${title.replace(/\s+/g, '_')}_${orderId}_${(clientName || '').replace(/\s+/g, '_')}.pdf`;
  doc.setProperties({ title: fileName });

  doc.setFontSize(18);
  doc.text(title, doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' });

  doc.setFontSize(12);
  let y = 35;
  doc.text(`Client: ${clientName || ''}`, 14, y);

  const dateFormatted = new Date().toLocaleDateString('fr-FR');
  doc.text(`Date: ${dateFormatted}`, doc.internal.pageSize.getWidth() - 14, y, { align: 'right' });

  if (comment) {
    y += 8;
    doc.setFontSize(10);
    doc.text(`Commentaire: ${comment}`, 14, y);
  }

  y += 10;

  const sorted = sortByColisage(products);

  const tableData = sorted.map(product => {
    const designation = buildDesignation(product);
    const lineTotal = bigDecimal.multiply(product.prixUnitaire_tmp, product.quantity) * 1;
    const row = [
      product.reference || '',
      String(product.quantity),
      designation,
    ];
    if (!hidePrices) {
      row.push((parseFloat(product.prixUnitaire_tmp) || 0).toFixed(2));
      row.push(lineTotal.toFixed(2));
    }
    row.push(product.commentaire || '');
    return row;
  });

  const head = hidePrices
    ? [['Référence', 'Quantité', 'Désignation', '#']]
    : [['Référence', 'Quantité', 'Désignation', 'P.U', 'Total HT', '#']];

  const columnStyles = hidePrices
    ? {
        0: { cellWidth: 28 },
        1: { cellWidth: 18, halign: 'center' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 20, halign: 'center' },
      }
    : {
        0: { cellWidth: 28 },
        1: { cellWidth: 18, halign: 'center' },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 22, halign: 'right' },
        4: { cellWidth: 25, halign: 'right' },
        5: { cellWidth: 20, halign: 'center' },
      };

  autoTable(doc, {
    startY: y,
    head,
    body: tableData,
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: [41, 41, 41], textColor: 255, fontStyle: 'bold' },
    columnStyles,
  });

  const finalY = doc.lastAutoTable.finalY + 10;

  const totalHT = sorted.reduce((sum, p) => {
    return bigDecimal.add(sum, bigDecimal.multiply(p.prixUnitaire_tmp, p.quantity)) * 1;
  }, 0);
  const totalTTC = bigDecimal.multiply(totalHT, 1.2) * 1;

  doc.setFontSize(11);
  const rightX = doc.internal.pageSize.getWidth() - 14;
  doc.setFont(undefined, 'normal');
  if (!hidePrices) {
    doc.text(`Total HT : ${totalHT.toFixed(2)} €`, rightX, finalY, { align: 'right' });
    doc.setFont(undefined, 'bold');
    doc.text(`Total TTC : ${totalTTC.toFixed(2)} €`, rightX, finalY + 8, { align: 'right' });
  }

  window.open(doc.output('bloburl'), '_blank');
}
